import Shepherd from 'shepherd.js'
import {highlightElStep, clickElStep} from './tours.js'

export function vetTourHook(tour) {
  let steps =
    [
      highlightElStep(tour, "Welcome to Sophie's Legacy", "Our goal is to improve client - vet interactions. As a clinic member we offer our check-in form tailored to your clinic and members (your clinic has opted-in to our program).", "#my-account", "bottom"),
      highlightElStep(tour, "Feedback", "Your check-in visits will appear here. Here are 3 examples. Each will have an option to set the interaction as positive or negative.", "#my-check-ins", "bottom"),
      clickElStep(tour, "Positive Visit", "After a positive experience with Henry and their owner we would mark it as 'Positive'. Click 'Positive' now.", ".positive-review-tutorial-0", "bottom"),
      clickElStep(tour, "Negative Visit", "After a negative experience with Molly and their owner we would mark it as 'Negative'. Click 'Negative' now.", ".negative-review-tutorial-1", "bottom"),
      highlightElStep(tour, "Negative Visit", "Tell us what worked and what didn't. We'll take you through a short tour on your first actual negative review.", ".negative-review-why-1", "bottom"),
      clickElStep(tour, "More Options", "In the app, you can click on banners like this to reveal a drop down menu providing more actions for the table.", ".target-open-settings", "bottom"),
      clickElStep(tour, "More Options", "You can set all non-reviewed visits as 'Positive' here. Click on Mark All Positive.", ".button-target-approve-all", "bottom"),

      // See this is marked as Positive now.
      // highlightElStep(tour, "Rerunning this Tour", "You can rerun this tour later from your settings page", "#my-settings-page", "bottom"),
      // Add step to show those as positive
      highlightElStep(tour, "More Options", "We have set this visit as 'Positive'. Please note we will archive any non-reviewed after one month for you.", ".positive-review-tutorial-2", "bottom"),
      clickElStep(tour, "Rerunning this Tour", "You can rerun this tour later from your settings page.", "#menu-opener", "bottom"),
      highlightElStep(tour, "All Done :)", "Thanks for your time! <br /> Your feedback helps us to understands the key issues around negative experiences. This summary data does not identify the vet or owner involved. We hope to use this data to improve our awareness campaign/future campaigns.", "#menu-closer", "bottom", true)
    ]

  tour.addSteps(steps);

  return {
    shouldRun() {
      return JSON.parse(this.el.dataset.should_run);
    },
    completeTour() {
      this.pushEvent("complete-vet-tour", {})
    },
    startTour() {
      tour.start();
      this.pushEvent("start-vet-tour", {})
    },
    mounted() {
      if (this.shouldRun()) {
        console.log("Starting Tour");
        this.startTour();
        tour.on("complete", _ => this.completeTour());
        tour.on("cancel", _ => this.completeTour());
      }
    }
  }
}

